import React,{useEffect} from "react";
import {Link} from "react-router-dom";
import * as Icons from "react-feather";
import AdminReport from "./AdminReport";
import ResellerReport from "./ResellerReport";
import CafeReport from "./CafeReport";
import DirectorReport from "./DirectorReport";
import {useAuth} from "store/auth";

import {
   Select,
   Loading
 } from "components/form";
export default function Dashboard() {
   const auth = useAuth();
   useEffect(() => {
      if (auth.getToken()) {
         auth.dispatch(auth.getDashboardData())
      }
    
   }, [])
   return (
      <>
         <div className="content">
           
            

           {auth.LoadDashboardData?(<div className="w-full flex justify-center"><Loading/></div>):(
            <div className="grid grid-cols-12 gap-6">
               <div className="col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                     {auth.userMeta &&
                     auth.userMeta.dashboardTypes.includes("ADMIN") &&auth.dashboardData&&auth.dashboardData.admin&& (
                        <AdminReport data={auth.dashboardData?.admin}/>
                     )}

                     {auth.userMeta &&
                     auth.userMeta.dashboardTypes.includes("DIRECTOR") &&auth.dashboardData&&auth.dashboardData.director&& (
                        <DirectorReport data={auth.dashboardData?.director}/>
                     )}

                     {auth.userMeta &&
                     auth.userMeta.dashboardTypes.includes("RESELLER") && (
                        <ResellerReport/>
                     )}
                     {auth.userMeta &&auth.dashboardData&&auth.dashboardData.cafe&&
                     auth.userMeta.dashboardTypes.includes("CAFE") && (
                        <CafeReport  data={auth.dashboardData?.cafe}/>
                     )}
                  </div>
               </div>
            </div>
            )}
         </div>
      </>
   );
}
